var _g;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgOrganizeMenu = function SvgOrganizeMenu(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 486.31 486.31",
    style: {
      enableBackground: "new 0 0 486.31 486.31"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.018,393.086c0.335,7.91,5.781,14.674,13.434,16.707l183.256,48.558c4.355,1.151,8.823,1.721,13.273,1.721 c5.718,0,11.416-0.936,16.878-2.818l247.238-85.063c7.655-2.633,12.633-10.029,12.185-18.109 c-0.446-8.084-6.211-14.882-14.107-16.66l-31.558-7.076l-203.079,69.875c-8.888,3.06-18.157,4.611-27.558,4.611 c-7.301,0-14.586-0.951-21.681-2.826L43.936,363.752l-31.974,11.52C4.518,377.955-0.334,385.176,0.018,393.086z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.018,305.044c0.335,7.91,5.797,14.677,13.449,16.709l183.24,48.556c4.355,1.154,8.823,1.73,13.273,1.73 c5.718,0,11.416-0.945,16.878-2.826l247.238-85.064c7.655-2.633,12.633-10.031,12.185-18.108 c-0.446-8.087-6.211-14.884-14.107-16.662l-31.558-7.076l-203.079,69.876c-8.888,3.059-18.157,4.603-27.558,4.603 c-7.301,0-14.586-0.943-21.681-2.817L43.936,275.711l-31.974,11.521C4.518,289.913-0.334,297.135,0.018,305.044z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.538,224.128c-8.888,3.059-18.157,4.604-27.558,4.604c-7.301,0-14.586-0.944-21.681-2.818L43.936,187.669 l-31.974,11.521c-7.444,2.682-12.296,9.904-11.944,17.814c0.335,7.908,5.797,14.674,13.449,16.707l183.24,48.557 c4.355,1.152,8.823,1.722,13.273,1.722c5.718,0,11.416-0.937,16.878-2.817l247.238-85.065c7.655-2.634,12.633-10.032,12.185-18.109 c-0.446-8.086-6.211-14.883-14.107-16.66l-31.558-7.078L237.538,224.128z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.452,145.662l183.256,48.557c4.355,1.152,8.823,1.721,13.273,1.721c5.718,0,11.416-0.937,16.878-2.818l247.238-85.063 c7.655-2.635,12.633-10.031,12.185-18.109c-0.446-8.087-6.211-14.883-14.107-16.661L268.008,27.494 c-3.748-0.841-7.557-1.256-11.352-1.256c-5.973,0-11.912,1.023-17.582,3.066L11.962,111.14 c-7.444,2.682-12.296,9.904-11.944,17.814C0.353,136.864,5.799,143.628,13.452,145.662z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOrganizeMenu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Organize Menu.8bbb684b.svg";
export { ForwardRef as ReactComponent };